<script>
export default {
  name: 'PrimaryLink',
  props: ['link', 'order', 'tabTrap']
}
</script>

<template>
  <a
    class="kb-burger-menu__link"
    :href="link.href"
    :target="link.target"
    @keydown.tab="tabTrap"
  >
    <div class="kb-icon" v-html="link.svgIcon"></div>
    <div class="kb-burger-menu__link-name">
      {{ link.text }}
      <div class="kb-ui-icon kb-ui-icon--ui-link"></div>
    </div>
  </a>
</template>
